import { autoSet, FC, useContext, useMemo} from 'external/react'
import { TextAreaField } from 'components/common/TextAreaField'

import { TeacherContext } from 'teacher/context'

export type SkillName = "communicative" | "ethical" | "logicalThinking" | "problemSolving" | "scientific" | "environmental" | "personalDevelopment"
export type SkillFieldName = "conceptual" | "procedural" | "attitudinal" | "achievementIndicators"

type SkillFieldProps = {
  className?: string
  skill: SkillName
  field: SkillFieldName
}

export const SkillField: FC<SkillFieldProps> = (props) => {

    const {skill, field, className} = props

    const {newPlan, translate, updateState} = useContext(TeacherContext) as any
    
    const unitPlan = useMemo(() => newPlan.content ? newPlan.content.unitPlan : undefined, [newPlan.content])
    const value =  useMemo(() => (unitPlan && unitPlan[skill] && unitPlan[skill][field]) || '', [unitPlan])

    function handleValueChange(value: string) {
      updateState({newPlan: autoSet(value, 'content', 'unitPlan', skill, field)})
    }

    return (<TextAreaField className={className} label={translate(`planning-rd-skill-${field}-label`)} onChange={handleValueChange} value={value} />)
}